// @ts-nocheck
// TODO: tighten types after migration
import React, { useState } from "react";
import "./AdminHome.css";
import WorldClock from "../components/WorldClock";
import ContentPlanner from "./ContentPlanner";
import { useNavPinned } from "./useNavPinned";
import AdminTopNav from "./AdminTopNav";

export default function AdminHome() {
    const [showClock, setShowClock] = useState(() => {
        if (typeof window !== 'undefined') {
            return window.innerWidth > 768;
        }
        return true;
    });
    const [navPinned, setNavPinned] = useNavPinned();

    return (
        <div className="admin-container w-full max-w-none px-0 pb-[20px]">
            <AdminTopNav activeTab="home" navPinned={navPinned} onTogglePin={() => setNavPinned(v => !v)} />
            <main className="admin-content">
                <div className="admin-dashboard-wrapper rounded-[14px] bg-bg p-[14px] shadow-[0_2px_12px_rgba(0,0,0,0.06)]">
                    <div className="admin-clock-section">
                        {showClock && <WorldClock />}
                    </div>
                    <div className="admin-welcome-section">
                        <div className="admin-welcome-header-group">
                            <h1 className="admin-welcome-heading text-[2rem] font-[800]">Welcome to Admin page</h1>
                        </div>
                    </div>
                    <div className="clock-toggle-wrapper">
                        <button
                            className="clock-toggle-btn"
                            onClick={() => setShowClock(!showClock)}
                            title={showClock ? "Hide Clock" : "Show Clock"}
                        >
                            <i className={`fi fi-sr-caret-down ${showClock ? "rotate-180" : ""}`}></i>
                        </button>
                    </div>
                </div>

                <ContentPlanner />
            </main>
        </div>
    );
}
